// GA4 계측 전체 on/off 플래그. false 면 플러그인이 스텁조차 만들지 않는다 (HIVER_NEW_PRODUCT_PAGE 와 같은 롤백 패턴)
export const ANALYTICS_ENABLED = true

// 옵트아웃 localStorage 키 prefix — `${prefix}${userId}` (예 ga:optout:s9626). 이 브라우저·이 도메인에 한정
export const OPTOUT_KEY_PREFIX = 'ga:optout:'
